<template>
  <HorizontalItemsDivider
    :items="breadcrumbs"
    align-items="start"
    :is-pdp="isPdp"
  >
    <template #default="{ items }">
      <LinkBreadcrumbs
        v-for="(link, idx) in items"
        :key="link.value"
        :to="toLocalePath(link.to)"
        only-exact-active
        :is-pdp="isPdp"
      >
        <span
          class="inline-block"
          :class="{
            'inline-block': !isPdp,
            'flex whitespace-nowrap': isPdp,
          }"
        >
          {{ link.value }}
        </span>
        <span
          v-if="showDividerTag(idx, items.length)"
          :key="`span-${link.value}`"
          class="inline-block pl-1.5 pr-2.5 align-middle"
        >
          <IconUiArrowRight />
        </span>
      </LinkBreadcrumbs>
    </template>
  </HorizontalItemsDivider>
</template>

<script lang="ts">
import type { BreadcrumbItem } from '@scayle/storefront-nuxt'
import HorizontalItemsDivider, {
  type DividerItem,
} from '../../ui/dividers/HorizontalItemsDivider.vue'
import LinkBreadcrumbs from '../../ui/links/LinkBreadcrumbs.vue'

export default defineComponent({
  name: 'Breadcrumbs',
  components: {
    HorizontalItemsDivider,
    LinkBreadcrumbs,
  },
  props: {
    links: {
      type: Array as PropType<BreadcrumbItem[]>,
      required: true,
    },
    isPdp: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
  setup(props) {
    const i18n = useI18n()
    const { toLocalePath } = useRouteHelpers()

    return {
      breadcrumbs: computed(
        () =>
          [
            { to: toLocalePath('/'), value: i18n.t('global.home') },
            ...props.links,
          ] as DividerItem[],
      ),
      toLocalePath,
    }
  },
})
</script>
